import styled from 'styled-components';

export const Container = styled.button`
  color: #878787;
  font-family: 'Roboto';
  font-size: 12px;
  font-weight: 400;
`;
